import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { configureProductionConsole } from './app/core/utils/production-console.util';

// Antes del bootstrap: silencia la consola en produccion, incluido lo que loguean las
// librerias de terceros (ver production-console.util.ts).
configureProductionConsole();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
